export default "__VITE_ASSET__D0USk9S4__"